// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 🎨 Paleta de Cores TTAP */
:root {
  /* Cores Primárias */
  --color-primary-dark: #2E005F;      /* Roxo Escuro - cabeçalhos, botões principais */
  --color-primary-medium: #5E17EB;    /* Roxo Médio - destaques e ícones */
  --color-primary-light: #A366FF;     /* Roxo Claro - fundos de seções */
  --color-accent: #CBB6FF;            /* Lilás Suave - hover e detalhes */
  
  /* Cores Neutras */
  --color-text-dark: #222222;         /* Textos principais */
  --color-background-light: #F5F5F7;  /* Fundos gerais */
  
  /* Cores com transparência para overlays */
  --color-primary-medium-alpha: rgba(94, 23, 235, 0.1);
  --color-primary-light-alpha: rgba(163, 102, 255, 0.1);
  --color-accent-alpha: rgba(203, 182, 255, 0.1);
}

/* Classes utilitárias para cores */
.bg-primary-dark { background-color: var(--color-primary-dark); }
.bg-primary-medium { background-color: var(--color-primary-medium); }
.bg-primary-light { background-color: var(--color-primary-light); }
.bg-accent { background-color: var(--color-accent); }
.bg-neutral-light { background-color: var(--color-background-light); }

.text-primary-dark { color: var(--color-primary-dark); }
.text-primary-medium { color: var(--color-primary-medium); }
.text-primary-light { color: var(--color-primary-light); }
.text-accent { color: var(--color-accent); }
.text-neutral-dark { color: var(--color-text-dark); }

.border-primary-medium { border-color: var(--color-primary-medium); }
.border-primary-light { border-color: var(--color-primary-light); }
.border-accent { border-color: var(--color-accent); }

/* Botões personalizados */
.btn-primary {
  background-color: var(--color-primary-medium);
  color: white;
  border: 2px solid var(--color-primary-medium);
  transition: all 0.3s ease;
}

.btn-primary:hover {
  background-color: var(--color-primary-light);
  border-color: var(--color-primary-light);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px var(--color-primary-medium-alpha);
}

.btn-secondary {
  background-color: var(--color-primary-light);
  color: white;
  border: 2px solid var(--color-primary-light);
  transition: all 0.3s ease;
}

.btn-secondary:hover {
  background-color: var(--color-accent);
  border-color: var(--color-accent);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px var(--color-primary-light-alpha);
}

.btn-accent {
  background-color: var(--color-accent);
  color: var(--color-primary-dark);
  border: 2px solid var(--color-accent);
  transition: all 0.3s ease;
}

.btn-accent:hover {
  background-color: var(--color-primary-light);
  border-color: var(--color-primary-light);
  color: white;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px var(--color-accent-alpha);
}

/* Cards com bordas coloridas */
.card-primary {
  border-left: 4px solid var(--color-primary-medium);
  box-shadow: 0 2px 8px var(--color-primary-medium-alpha);
}

.card-secondary {
  border-left: 4px solid var(--color-primary-light);
  box-shadow: 0 2px 8px var(--color-primary-light-alpha);
}

.card-accent {
  border-left: 4px solid var(--color-accent);
  box-shadow: 0 2px 8px var(--color-accent-alpha);
}

/* Inputs personalizados */
.input-primary {
  border: 2px solid var(--color-accent);
  transition: all 0.3s ease;
}

.input-primary:focus {
  border-color: var(--color-primary-medium);
  box-shadow: 0 0 0 2px var(--color-primary-medium-alpha);
  outline: none;
}

/* Gradientes */
.gradient-primary {
  background: linear-gradient(135deg, var(--color-primary-dark) 0%, var(--color-primary-medium) 100%);
}

.gradient-secondary {
  background: linear-gradient(135deg, var(--color-primary-medium) 0%, var(--color-primary-light) 100%);
}

.gradient-accent {
  background: linear-gradient(135deg, var(--color-primary-light) 0%, var(--color-accent) 100%);
}

/* Estados de hover para elementos interativos */
.hover-primary:hover {
  background-color: var(--color-primary-medium);
  color: white;
  transition: all 0.3s ease;
}

.hover-secondary:hover {
  background-color: var(--color-primary-light);
  color: white;
  transition: all 0.3s ease;
}

.hover-accent:hover {
  background-color: var(--color-accent);
  color: var(--color-primary-dark);
  transition: all 0.3s ease;
}

/* Sidebar e navegação */
.sidebar-primary {
  background: var(--color-primary-dark);
  color: white;
}

.sidebar-item:hover {
  background-color: var(--color-primary-medium);
  border-radius: 8px;
  margin: 2px 8px;
}

/* Headers */
.header-primary {
  background: var(--color-primary-dark);
  color: white;
  box-shadow: 0 2px 8px var(--color-primary-medium-alpha);
}

/* Tabelas */
.table-header {
  background-color: var(--color-background-light);
  color: var(--color-primary-dark);
  font-weight: 600;
}

.table-row:hover {
  background-color: var(--color-accent-alpha);
}

/* Status badges */
.badge-success {
  background-color: #10B981;
  color: white;
}

.badge-warning {
  background-color: #F59E0B;
  color: white;
}

.badge-error {
  background-color: #EF4444;
  color: white;
}

.badge-info {
  background-color: var(--color-primary-medium);
  color: white;
}

/* Animações */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-fade-in-up {
  animation: fadeInUp 0.5s ease-out;
}

/* Componentes específicos */
.loading-spinner {
  border: 3px solid var(--color-accent);
  border-top: 3px solid var(--color-primary-medium);
  border-radius: 50%;
  width: 20px;
  height: 20px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Scrollbar personalizada */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: var(--color-background-light);
}

::-webkit-scrollbar-thumb {
  background: var(--color-accent);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--color-primary-light);
}

`, "",{"version":3,"sources":["webpack://./src/styles/colors.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,oBAAoB;EACpB,6BAA6B,OAAO,gDAAgD;EACpF,+BAA+B,KAAK,oCAAoC;EACxE,8BAA8B,MAAM,kCAAkC;EACtE,uBAAuB,aAAa,mCAAmC;;EAEvE,kBAAkB;EAClB,0BAA0B,UAAU,sBAAsB;EAC1D,iCAAiC,GAAG,kBAAkB;;EAEtD,0CAA0C;EAC1C,oDAAoD;EACpD,qDAAqD;EACrD,8CAA8C;AAChD;;AAEA,mCAAmC;AACnC,mBAAmB,2CAA2C,EAAE;AAChE,qBAAqB,6CAA6C,EAAE;AACpE,oBAAoB,4CAA4C,EAAE;AAClE,aAAa,qCAAqC,EAAE;AACpD,oBAAoB,+CAA+C,EAAE;;AAErE,qBAAqB,gCAAgC,EAAE;AACvD,uBAAuB,kCAAkC,EAAE;AAC3D,sBAAsB,iCAAiC,EAAE;AACzD,eAAe,0BAA0B,EAAE;AAC3C,qBAAqB,6BAA6B,EAAE;;AAEpD,yBAAyB,yCAAyC,EAAE;AACpE,wBAAwB,wCAAwC,EAAE;AAClE,iBAAiB,iCAAiC,EAAE;;AAEpD,0BAA0B;AAC1B;EACE,6CAA6C;EAC7C,YAAY;EACZ,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA;EACE,4CAA4C;EAC5C,wCAAwC;EACxC,2BAA2B;EAC3B,wDAAwD;AAC1D;;AAEA;EACE,4CAA4C;EAC5C,YAAY;EACZ,4CAA4C;EAC5C,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,iCAAiC;EACjC,2BAA2B;EAC3B,uDAAuD;AACzD;;AAEA;EACE,qCAAqC;EACrC,gCAAgC;EAChC,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,4CAA4C;EAC5C,wCAAwC;EACxC,YAAY;EACZ,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA,+BAA+B;AAC/B;EACE,kDAAkD;EAClD,uDAAuD;AACzD;;AAEA;EACE,iDAAiD;EACjD,sDAAsD;AACxD;;AAEA;EACE,0CAA0C;EAC1C,+CAA+C;AACjD;;AAEA,0BAA0B;AAC1B;EACE,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,uDAAuD;EACvD,aAAa;AACf;;AAEA,eAAe;AACf;EACE,mGAAmG;AACrG;;AAEA;EACE,oGAAoG;AACtG;;AAEA;EACE,4FAA4F;AAC9F;;AAEA,gDAAgD;AAChD;EACE,6CAA6C;EAC7C,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,4CAA4C;EAC5C,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,6CAA6C;EAC7C,kBAAkB;EAClB,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,qCAAqC;EACrC,YAAY;EACZ,uDAAuD;AACzD;;AAEA,YAAY;AACZ;EACE,+CAA+C;EAC/C,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,6CAA6C;EAC7C,YAAY;AACd;;AAEA,cAAc;AACd;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,iCAAiC;AACnC;;AAEA,4BAA4B;AAC5B;EACE,qCAAqC;EACrC,iDAAiD;EACjD,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,4BAA4B;AAC5B;EACE,UAAU;AACZ;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;AACxC","sourcesContent":["/* 🎨 Paleta de Cores TTAP */\n:root {\n  /* Cores Primárias */\n  --color-primary-dark: #2E005F;      /* Roxo Escuro - cabeçalhos, botões principais */\n  --color-primary-medium: #5E17EB;    /* Roxo Médio - destaques e ícones */\n  --color-primary-light: #A366FF;     /* Roxo Claro - fundos de seções */\n  --color-accent: #CBB6FF;            /* Lilás Suave - hover e detalhes */\n  \n  /* Cores Neutras */\n  --color-text-dark: #222222;         /* Textos principais */\n  --color-background-light: #F5F5F7;  /* Fundos gerais */\n  \n  /* Cores com transparência para overlays */\n  --color-primary-medium-alpha: rgba(94, 23, 235, 0.1);\n  --color-primary-light-alpha: rgba(163, 102, 255, 0.1);\n  --color-accent-alpha: rgba(203, 182, 255, 0.1);\n}\n\n/* Classes utilitárias para cores */\n.bg-primary-dark { background-color: var(--color-primary-dark); }\n.bg-primary-medium { background-color: var(--color-primary-medium); }\n.bg-primary-light { background-color: var(--color-primary-light); }\n.bg-accent { background-color: var(--color-accent); }\n.bg-neutral-light { background-color: var(--color-background-light); }\n\n.text-primary-dark { color: var(--color-primary-dark); }\n.text-primary-medium { color: var(--color-primary-medium); }\n.text-primary-light { color: var(--color-primary-light); }\n.text-accent { color: var(--color-accent); }\n.text-neutral-dark { color: var(--color-text-dark); }\n\n.border-primary-medium { border-color: var(--color-primary-medium); }\n.border-primary-light { border-color: var(--color-primary-light); }\n.border-accent { border-color: var(--color-accent); }\n\n/* Botões personalizados */\n.btn-primary {\n  background-color: var(--color-primary-medium);\n  color: white;\n  border: 2px solid var(--color-primary-medium);\n  transition: all 0.3s ease;\n}\n\n.btn-primary:hover {\n  background-color: var(--color-primary-light);\n  border-color: var(--color-primary-light);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px var(--color-primary-medium-alpha);\n}\n\n.btn-secondary {\n  background-color: var(--color-primary-light);\n  color: white;\n  border: 2px solid var(--color-primary-light);\n  transition: all 0.3s ease;\n}\n\n.btn-secondary:hover {\n  background-color: var(--color-accent);\n  border-color: var(--color-accent);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px var(--color-primary-light-alpha);\n}\n\n.btn-accent {\n  background-color: var(--color-accent);\n  color: var(--color-primary-dark);\n  border: 2px solid var(--color-accent);\n  transition: all 0.3s ease;\n}\n\n.btn-accent:hover {\n  background-color: var(--color-primary-light);\n  border-color: var(--color-primary-light);\n  color: white;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px var(--color-accent-alpha);\n}\n\n/* Cards com bordas coloridas */\n.card-primary {\n  border-left: 4px solid var(--color-primary-medium);\n  box-shadow: 0 2px 8px var(--color-primary-medium-alpha);\n}\n\n.card-secondary {\n  border-left: 4px solid var(--color-primary-light);\n  box-shadow: 0 2px 8px var(--color-primary-light-alpha);\n}\n\n.card-accent {\n  border-left: 4px solid var(--color-accent);\n  box-shadow: 0 2px 8px var(--color-accent-alpha);\n}\n\n/* Inputs personalizados */\n.input-primary {\n  border: 2px solid var(--color-accent);\n  transition: all 0.3s ease;\n}\n\n.input-primary:focus {\n  border-color: var(--color-primary-medium);\n  box-shadow: 0 0 0 2px var(--color-primary-medium-alpha);\n  outline: none;\n}\n\n/* Gradientes */\n.gradient-primary {\n  background: linear-gradient(135deg, var(--color-primary-dark) 0%, var(--color-primary-medium) 100%);\n}\n\n.gradient-secondary {\n  background: linear-gradient(135deg, var(--color-primary-medium) 0%, var(--color-primary-light) 100%);\n}\n\n.gradient-accent {\n  background: linear-gradient(135deg, var(--color-primary-light) 0%, var(--color-accent) 100%);\n}\n\n/* Estados de hover para elementos interativos */\n.hover-primary:hover {\n  background-color: var(--color-primary-medium);\n  color: white;\n  transition: all 0.3s ease;\n}\n\n.hover-secondary:hover {\n  background-color: var(--color-primary-light);\n  color: white;\n  transition: all 0.3s ease;\n}\n\n.hover-accent:hover {\n  background-color: var(--color-accent);\n  color: var(--color-primary-dark);\n  transition: all 0.3s ease;\n}\n\n/* Sidebar e navegação */\n.sidebar-primary {\n  background: var(--color-primary-dark);\n  color: white;\n}\n\n.sidebar-item:hover {\n  background-color: var(--color-primary-medium);\n  border-radius: 8px;\n  margin: 2px 8px;\n}\n\n/* Headers */\n.header-primary {\n  background: var(--color-primary-dark);\n  color: white;\n  box-shadow: 0 2px 8px var(--color-primary-medium-alpha);\n}\n\n/* Tabelas */\n.table-header {\n  background-color: var(--color-background-light);\n  color: var(--color-primary-dark);\n  font-weight: 600;\n}\n\n.table-row:hover {\n  background-color: var(--color-accent-alpha);\n}\n\n/* Status badges */\n.badge-success {\n  background-color: #10B981;\n  color: white;\n}\n\n.badge-warning {\n  background-color: #F59E0B;\n  color: white;\n}\n\n.badge-error {\n  background-color: #EF4444;\n  color: white;\n}\n\n.badge-info {\n  background-color: var(--color-primary-medium);\n  color: white;\n}\n\n/* Animações */\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.animate-fade-in-up {\n  animation: fadeInUp 0.5s ease-out;\n}\n\n/* Componentes específicos */\n.loading-spinner {\n  border: 3px solid var(--color-accent);\n  border-top: 3px solid var(--color-primary-medium);\n  border-radius: 50%;\n  width: 20px;\n  height: 20px;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Scrollbar personalizada */\n::-webkit-scrollbar {\n  width: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: var(--color-background-light);\n}\n\n::-webkit-scrollbar-thumb {\n  background: var(--color-accent);\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: var(--color-primary-light);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
